var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('handel-click')}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('ButtonArrow',{attrs:{"state":_vm.isOpen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }